import { enableHMRForChain } from "@husky-hrc/Utilities/Utilities";

import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CallAddWishListLinesApi, chain } from "@insite/client-framework/Store/Pages/MyLists/Handlers/AddWishListLines";

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";

enableHMRForChain(chain);

type addWishListLinesProps = Parameters<typeof CallAddWishListLinesApi>[0];

export const LoadCart = (props: addWishListLinesProps) => {
    props.dispatch(loadCurrentCart());
};

addToChainAfter(chain, CallAddWishListLinesApi, LoadCart);
